import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import 'rxjs/add/observable/throw';
import { catchError } from 'rxjs/operators';
import { environment } from "../../../../environments/environment";
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class TestHistoryService {

    constructor(private http: HttpClient ,private cookieService: CookieService) { }

    testHistory():Observable <any> {
      return this.http.get<any>(`${environment.userHost}/test_history/${this.cookieService.get('_PAOID')}`)
    }
    viewSolutionsTestadmins(body:any): Observable<any> {
        body.org_id = this.cookieService.get('_PAOID')
        return this.http.post<any>(`${environment.authorHost}/view_solutions_testadmin`, body)
    }
    
    testSummarys(body:any): Observable<any> {
        return this.http.post<any>(`${environment.userHost}/test_summary`, body)
    }
  
    certificateDownloads(InsId:any): Observable<any> {
      return this.http.get<any>(`${environment.userHost}/certificate/${InsId}`)
    }
  getExaminerComment(body: any): Observable<any> {
    body.org_id = this.cookieService.get('_PAOID')
      return this.http.post<any>(`${environment.authorHost}/get_examiner_comment`, body)
  }
  getRubric(body: any): Observable<any> {
    body.org_Id = this.cookieService.get('_PAOID')
      return this.http.post<any>(`${environment.authorHost}/rubric`, body)
  }
    

}



// WEBPACK FOOTER //
// ./src/app/application/services/api-service/test-history.service.ts